






















































































































































































































































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { Coupon, Tenant } from "@/models";
import { UsableTime } from "@/models/coupon";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef, DocData } from "@/stores";
import { form, autoclose, shopBase } from "@/mixins";
import { alert, confirm } from "@/services/dialog";
import draggable from "vuedraggable";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import { default as loadImage, parseMetaData } from "blueimp-load-image";
import { v4 as Uuidv4 } from "uuid";
import dayjs from "dayjs";
import { ShopCategoryType } from "@/models/tenant";

const db = firebaseProject.firestore();
interface TenantData {
  tenantId: string;
  shopName?: string;
  shopCategoryType?: ShopCategoryType;
  check: boolean;
  maximumNumber?: number | null;
}
export default shopBase.extend(Vue).extend({
  name: "shopqreCouponDetail",
  mixins: [form, autoclose],
  components: { VueCtkDateTimePicker, draggable },
  data(): {
    authentication: object;
    transitionName: string;
    justifyNow: boolean;
    imageEditor: boolean;
    uploadingFile: boolean;
    replaceIndex: number;
    editedImage: string[];
    guide: string;
    notice: string;
    shopCategoryType: ShopCategoryType | string | undefined;
    tenantDatas: TenantData[];
    tenantSelectedAll: boolean;
  } {
    return {
      authentication,
      transitionName: "",
      justifyNow: false,
      imageEditor: false,
      uploadingFile: false,
      replaceIndex: -1,
      editedImage: [],
      guide: "",
      notice: "",
      shopCategoryType: "0",
      tenantDatas: [],
      tenantSelectedAll: false
    };
  },
  async created() {
    const docId = this.$route.params.id;
    if (docId) {
      const _doc = await this.document.ref?.get();
      if (_doc) {
        this.guide = _doc.data()?.guide || "";
        this.notice = _doc.data()?.notice || "";
      }
    }
    const tenantDocs = await db
      .collection("tenant")
      .where("shopId", "==", this.shopId)
      .get()
      .then(snapshot => {
        return snapshot.docs.map(doc => {
          return new DocDataRef({
            document: doc.data() as Tenant,
            id: doc.id,
            ref: doc.ref
          } as DocData<Tenant>);
        });
      });

    tenantDocs.map(doc => {
      const tenantSelectedDatas =
        this.document.effective.tenantSelectedDatas ?? [];
      const tenantSelectedData = tenantSelectedDatas.find(
        item => item.tenantId == doc.id
      );
      if (this.tenantStatus(doc) === 1) {
        this.tenantDatas.push({
          tenantId: doc.id,
          shopName: doc.document?.shopName,
          shopCategoryType: doc.document?.shopCategoryType,
          check: tenantSelectedData ? true : false
        });
      }
    });
  },
  computed: {
    collection(): Collection<Coupon> {
      return new Collection(
        db.collection("coupon") as firestore.CollectionReference<Coupon>
      );
    },
    document(): Document<Coupon> {
      const id = this.$route.params.id;
      return this.collection.doc(id, { noListen: true });
    },
    usableTime(): UsableTime {
      if (this.document.effective.usableTime) {
        return this.document.effective?.usableTime;
      }
      return { from: "", to: "" };
    },
    usableTimeFrom: {
      get(): string {
        return this.usableTime.from;
      },
      set(value: string) {
        this.document.effective.usableTime = this.usableTime;
        this.document.effective.usableTime.from = value;
      }
    },
    usableTimeTo: {
      get(): string {
        return this.usableTime.to;
      },
      set(value: string) {
        this.document.effective.usableTime = this.usableTime;
        this.document.effective.usableTime.to = value;
      }
    },
    basepath(): string {
      return "shop/" + this.shopId + "/";
    },
    pageTitle(): string {
      const id = this.$route.params.id;
      return id ? "謝礼クーポン詳細" : "謝礼クーポン新規登録";
    },
    pageHeader(): string {
      const id = this.$route.params.id;
      return id ? "詳細" : "新規謝礼クーポン";
    },
    saveButtonName(): string {
      return this.document?.data?.publishStatus != 2 ? "下書き保存" : "保存";
    },
    filterTenantDataByCategory(): TenantData[] | undefined {
      const data =
        this.tenantDatas.filter(data => {
          return (
            this.shopCategoryType == "0" ||
            data.shopCategoryType == this.shopCategoryType
          );
        }) || [];
      return data.sort((a, b) => {
        if (a.shopName !== undefined && b.shopName !== undefined) {
          return a.shopName?.localeCompare(b.shopName, "ja");
        }
        return 0;
      });
    },
    filterTenantDataByCheck(): TenantData[] | undefined {
      const data =
        this.tenantDatas.filter(data => {
          return data.check;
        }) || [];
      return data.sort((a, b) => {
        if (a.shopName !== undefined && b.shopName !== undefined) {
          return a.shopName?.localeCompare(b.shopName, "ja");
        }
        return 0;
      });
    }
  },
  methods: {
    async register() {
      if (
        this.document.effective.pushSend &&
        !this.document.effective.pushStatus
      ) {
        if (dayjs(this.document.effective.pushAt).valueOf() < Date.now()) {
          await alert({
            title: "エラー",
            text: "プッシュ配信を行う場合、配信日時は未来を設定してください。"
          });
          return;
        }
      }
      if (
        !this.document.effective.unlimited &&
        !this.document.effective.publishUnlimited
      ) {
        if (
          dayjs(this.document.effective.publishFrom).valueOf() >
          dayjs(this.document.effective.availableTo).valueOf()
        ) {
          await alert({
            title: "エラー",
            text: "掲載期間、利用期間を正しく設定してください。"
          });
          return;
        }
        if (
          dayjs(this.document.effective.publishTo).valueOf() <
          dayjs(this.document.effective.availableFrom).valueOf()
        ) {
          await alert({
            title: "エラー",
            text: "掲載期間、利用期間を正しく設定してください。"
          });
          return;
        }
      }
      if (this.document.effective.guide != this.guide) {
        this.document.effective.guide = this.guide;
      }
      if (this.document.effective.notice != this.notice) {
        this.document.effective.notice = this.notice;
      }
      if (!this.document.effective.aiCouponCode) {
        this.document.effective.aiCouponCode = await this.generateAiCouponCode();
      }
      this.document.effective.tenantSelectedDatas = [];
      for (const tenantData of this.tenantDatas) {
        if (tenantData.check) {
          this.document.effective.tenantSelectedDatas.push({
            tenantId: tenantData.tenantId
          });
        }
      }
      if (
        this.document.effective.shopId &&
        this.document.effective.shopId != this.shopId
      ) {
        alert({
          title: "エラー",
          text: "操作対象SCが異なるため、保存できません。"
        });
        return;
      }
      if (this.document.canSave) {
        this.document.effective.categoryId = "QreCoupon";
        this.document.effective.label = "10";
        this.document.effective.isQreCoupon = 1;
        this.document.effective.tenantId = null;
        this.document.effective.shopId = this.shopId;
        const result = await this.document.save().catch(e => {
          console.log(e);
          alert({
            title: "エラー",
            text: "クーポンの保存に失敗しました。"
          });
        });
        if (result) {
          this.$router.push("/shopqre/coupon");
        }
      } else {
        this.$router.push("/shopqre/coupon");
      }
    },
    async registerAndPublish() {
      this.document.effective.publishStatus = 2;
      await this.register();
    },
    async deleteDocument() {
      const result = await this.document.remove();
      if (result && result.successed) {
        this.$router.push("/shopqre/coupon");
      } else {
        alert({
          title: "エラー",
          text: "削除できませんでした。"
        });
      }
    },
    selectImage() {
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteImage(index: number) {
      if (this.document?.effective.image) {
        this.document.effective.image.splice(index, 1);
        this.document.effective.image = [...this.document.effective.image];
      }
    },
    openImageEditor() {
      const images = this.document?.effective.image || [];
      this.editedImage = [...images];
      this.imageEditor = true;
    },
    closeImageEditor(save: boolean) {
      if (this.uploadingFile) {
        return;
      }
      if (save) {
        this.document.effective.image = [...this.editedImage];
      }
      this.replaceIndex = -1;
      this.imageEditor = false;
    },
    selectEditImage(index: number) {
      this.replaceIndex = index;
      (this.$refs.fileupload as HTMLInputElement).click();
    },
    deleteEditImage(index: number) {
      this.editedImage.splice(index, 1);
    },
    async uploadFile(event: Event) {
      this.uploadingFile = true;
      if (event.target instanceof HTMLInputElement) {
        if (!event.target.files || event.target.files.length <= 0) {
          alert({
            title: "エラー",
            text: "ファイルを選択、もしくは撮影してください。"
          });
          event.target.value = "";
          this.uploadingFile = false;
        } else {
          // const _this = this;
          event.target.files.forEach((item: File) => {
            loadImage(
              item,
              img => {
                //upload to firebase storage
                const _path = this.basepath + Uuidv4() + ".jpg";
                const ref = firebaseProject
                  .storage()
                  .ref()
                  .child(_path);
                const type = "image/jpeg";
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const dataUri = (img as any).toDataURL(type, 0.8);
                const bin = atob(dataUri.split(",")[1]);
                const buffer = new Uint8Array(bin.length);
                for (let i = 0; i < bin.length; i++) {
                  buffer[i] = bin.charCodeAt(i);
                }
                const blob = new Blob([buffer.buffer], { type: type });
                ref
                  .put(blob, { contentType: type })
                  .then(snapshot => {
                    return snapshot.ref.getDownloadURL();
                  })
                  .then(downloadURL => {
                    if (this.document.effective.image == undefined) {
                      this.document.effective.image = [];
                    }
                    const url = _path;
                    if (this.replaceIndex > -1) {
                      this.editedImage.splice(this.replaceIndex, 1, url);
                    } else {
                      const newArr = this.document.effective.image.slice(
                        0,
                        this.document.effective.image.length
                      );
                      newArr.push(url);
                      this.document.effective.image = newArr;
                    }
                    this.uploadingFile = false;
                  })
                  .catch(error => {
                    console.log(error);
                    this.uploadingFile = false;
                  });
              },
              {
                maxWidth: 1200,
                maxHeight: 1200,
                canvas: true
              }
            );
          });
          event.target.value = "";
        }
      }
    },
    async generateAiCouponCode() {
      let aiCouponCode = "";
      while (aiCouponCode == "") {
        const tmpAiCouponCode = (
          "00000000" + Math.floor(Math.random() * 100000000)
        ).slice(-8);
        // クーポンコードの重複チェック
        const existCoupons = await (db.collection(
          `/coupon`
        ) as firestore.CollectionReference<Coupon>)
          .where("aiCouponCode", "==", tmpAiCouponCode)
          .get();
        if (!existCoupons.docs.length) {
          aiCouponCode = tmpAiCouponCode;
        }
      }
      return aiCouponCode;
    },
    changeShopCategoryType() {
      this.tenantSelectedAll = false;
    },
    changeTenantSelectedAll() {
      for (const key in this.tenantDatas) {
        const tenantData = this.tenantDatas[key];
        if (
          this.shopCategoryType == "0" ||
          tenantData.shopCategoryType == this.shopCategoryType
        ) {
          this.tenantDatas[key].check = this.tenantSelectedAll;
        }
      }
    },
    changeMaximumNumber(event: any) {
      // 0以下、もしくは整数以外の場合は無効にする
      const value = Number(event?.target?.value);
      if (value <= 0 || !Number.isInteger(value)) {
        this.document.effective.maximumNumber = null;
        event.target.value = null;
      } else {
        this.document.effective.maximumNumber = value;
      }
    },
    disableInputDotAndHyphen(event: any) {
      // 「.」と「-」の入力を無効にする
      if (event?.key == "." || event?.key == "-") {
        event.preventDefault();
      }
    }
  }
});
